import { Component, ElementRef, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import {Translate} from 'src/shared/translate';
@Component({
    selector: 'TranslateElem',
    templateUrl: './translateElem.component.html',
    styleUrls: ['./translateElem.component.scss'],
})
export class TranslateElem{
    @ViewChild('translateElement') elem;
    @ViewChild('ok') okElem;
    @ViewChild('cancel') closeElem;
    
    @Input() add: string = "";
    @Input() add2: string = "";
    @Input() add3: string = "";
    @Input() add4: string = "";

    @Input() t1: string = "";
    @Input() t2: string = "";
    @Input() t3: string = "";
    @Input() t4: string = "";

    @Input() okName: string = "Ok";
    @Input() closeName: string = "Cancel"; 
    @Output() closeRequest = new EventEmitter<any>();
    @Output() okRequest = new EventEmitter<any>();
    constructor(private el: ElementRef){}

    ngAfterViewInit(){
        if(this.el.nativeElement.getAttribute('paramdata') !== undefined){
            this.elem.nativeElement.innerHTML = Translate.languages[Translate.getCurrentLanguage()][this.el.nativeElement.getAttribute('paramdata')];
        }
        if(this.t1 != ""){
            this.elem.nativeElement.innerHTML += Translate.languages[Translate.getCurrentLanguage()][this.t1];
        }
        if(this.add != ""){
            this.elem.nativeElement.innerHTML += this.add;
        }
        if(this.t2 != ""){
            this.elem.nativeElement.innerHTML += Translate.languages[Translate.getCurrentLanguage()][this.t2];
        }
        if(this.add2 != ""){
            this.elem.nativeElement.innerHTML += this.add2;
        }
        if(this.t3 != ""){
            this.elem.nativeElement.innerHTML += Translate.languages[Translate.getCurrentLanguage()][this.t3];
        }
        if(this.add3 != ""){
            this.elem.nativeElement.innerHTML += this.add3;
        }
        if(this.t4 != ""){
            this.elem.nativeElement.innerHTML += Translate.languages[Translate.getCurrentLanguage()][this.t4];
        }
        if(this.add4 != ""){
            this.elem.nativeElement.innerHTML += this.add4;
        }
        
        this.okElem.nativeElement.innerHTML = Translate.languages[Translate.getCurrentLanguage()][this.okName];
        this.closeElem.nativeElement.innerHTML = Translate.languages[Translate.getCurrentLanguage()][this.closeName];
        if(this.isOverflown(document.getElementById("smartText")) == false){
            document.getElementById("smartText").style.display = "flex";
            document.getElementById("smartText").style.flexWrap = "wrap";
            document.getElementById("smartText").style.alignContent = "center";
            document.getElementById("smartText").style.justifyContent = "center";
            document.getElementById("smartText").style.textAlign = "center";
        }
    }
    ionViewDidEnter(){
        this.elem.innerHTML = Translate.languages[Translate.getCurrentLanguage()][this.el.nativeElement.getAttribute('paramdata')];
    }
    alertGiven: boolean = false;

    close() {
        var modal = document.getElementById("myModal");
        modal.style.display = "none";
        this.alertGiven = true;
        this.closeRequest.emit(null);
    }

    closeOk(){
        var modal = document.getElementById("myModal");
        modal.style.display = "none";
        this.okRequest.emit(null);
        this.closeRequest.emit(null);
    }

    isOverflown(element) {
        return element.scrollHeight > element.clientHeight; // || element.scrollWidth > element.clientWidth;
    }
}



@Component({
    selector: 'TranslateWord',
    template: '<span #translateElement></span>',
    styleUrls: ['./translateElem.component.scss'],
})
export class TranslateWord{
    @ViewChild('translateElement') elem;
    @Input() translation = ""; 
    ngAfterViewInit(){
        if(this.translation != ""){
            this.elem.nativeElement.innerHTML = Translate.languages[Translate.getCurrentLanguage()][this.translation];
        }
    }
}
